module.exports = {
    DELETE_LEAVE: "Are you sure you want to delete this leave?",
}